import { render, staticRenderFns } from "./StandardPolicyCancel.vue?vue&type=template&id=a6c74688&scoped=true&"
import script from "./StandardPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./StandardPolicyCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c74688",
  null
  
)

export default component.exports